import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { ArrowLeftIcon } from "@/assets/icons";
import { DatasetDetailSessionStorageProps } from "@/components/datasetManagement/details/ActionPanel/FormActionPanel";
import { useMap } from "@/hooks/map/core/useMapContext";
import useSessionStorage from "@/hooks/store/useSessionStorage";
import { RootState } from "@/store";
import {
  disabledCustomDrawPolygonDataset,
  disableDrawPolygon,
  setShowPanelDatasetDetail
} from "@/store/slice/uiSlice";

export default function DrawPolygonPanel() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { sessionValue: sessionData, setSessionItem: setItem } =
    useSessionStorage(
      "dataset-detail-draw-polygon",
      {} as DatasetDetailSessionStorageProps
    );
  const { isCustomDrawPolygonDataset } = useSelector(
    (state: RootState) => state.ui
  );
  const { drawnPolygon } = useSelector((state: RootState) => state.spatial);

  const { exitDrawMode, map } = useMap();

  const handleCloseDrawPolygon = useCallback(() => {
    dispatch(disableDrawPolygon());
    exitDrawMode();
    if (isCustomDrawPolygonDataset && map) {
      if (drawnPolygon) {
        const canvas = map.getCanvas();
        const dataURL = canvas.toDataURL("image/png");
        setItem({
          ...sessionData,
          image: { ...sessionData.image, [sessionData.name as string]: dataURL }
        });
      }
      dispatch(disabledCustomDrawPolygonDataset());
      dispatch(
        setShowPanelDatasetDetail({
          isAddNewRow: sessionData?.type === "add",
          isEditRow: sessionData?.type === "edit"
        })
      );
      navigate(`dataset-management/${sessionData?.id}`);
    }
  }, [
    dispatch,
    drawnPolygon,
    exitDrawMode,
    isCustomDrawPolygonDataset,
    map,
    navigate,
    sessionData,
    setItem
  ]);

  return (
    <>
      <div className="flex flex-row items-center absolute top-5 left-5 bg-white z-50 w-[355px] p-3 rounded-xl shadow-[0px_4px_24px_5px_rgba(206,206,206,0.40)]">
        <button type="button" onClick={handleCloseDrawPolygon}>
          <ArrowLeftIcon className="mr-1 fill-dim-gray size-5" />
        </button>
        <div className="h-full text-sm font-semibold text-txtHeading">
          Custom Polygon
        </div>
      </div>
    </>
  );
}
